<template>
  <div class="main-box">

    <el-row :gutter="20">
      <el-col :span="12">
        <div class="left-box department grid-content ep-bg-purple"
          style="display: flex;flex-direction: column;align-items: self-start;">
          <div style="margin: 10px 20px;">
            <span>部门列表(当前操作部门为：</span>
            <span v-if="departmentIndex">
              <span style="color:#79BBFF;font-weight: 600;">{{departmentIndex.name}}</span>
              )</span>
          </div>

          <el-table :data="departmentList" style="width: 100%">
            <el-table-column prop="id" label="部门ID" />
            <el-table-column prop="name" label="部门名称" />
            <el-table-column prop="description" label="部门描述" />

            <el-table-column label="操作">
              <template #default="{ row }">
                <el-button type="primary" @click="getDepartmentIsResource(row)" size="small">分配</el-button>

              </template>
            </el-table-column>
          </el-table>







        </div>
      </el-col>
      <el-col :span="12">
        <div class="lright-box resource grid-content ep-bg-purple">
          <div style="margin: 10px 0;display: flex;justify-content: space-between;">
            <span>可分配资源</span>
            <el-button type="primary" round style="margin-right:60px"
              @click="allocationDepartmenttFunction">一键分配</el-button>
          </div>
          <div>
            <span style="font-size: 0.8em;color:#FBDED6">选择部门后已经勾选的权限为已有权限，如要删除，取消勾选已有权限即可，如要新增，勾选新的资源即可</span>
          </div>
          <div>
            <!-- <el-checkbox v-for="(resourceListItem,resourceListIndex) in resourceList" :key="resourceListIndex"
              v-model="checked1" label="Option 1" size="large" /> -->
            <div class="resourceBox" v-for="(resourceListItem,resourceListIndex) in resourceList"
              :key="resourceListIndex">
              <div class="resourceTitle" style="color:#AAAAAA;padding: 8px 0px;margin: 8px 0px;">
                {{resourceListItem.name}}：
              </div>
              <el-checkbox v-for="(resourceListItemList,resourceListItemIndex) in resourceListItem.list"
                :key="resourceListItemIndex" v-model="checkedList" :label="resourceListItemList.name" size="large"
                :value="resourceListItemList.id" />



            </div>
          </div>

        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script setup>
  import {
    ElMessage
  } from "element-plus";
  import {
    onMounted,
    reactive,
    ref
  } from "vue";
  import {
    getdepartmentlist,
    getAllDepartmentResourceList,
    allocationDepartment,
    getDepartmentResourceList
  } from "@/api/api";
  onMounted(() => {
    getdepartmentlistFunction()
    getAllDepartmentResourceListFunction()

  });

  const departmentIndex = ref(0); //当前选择的部门索引，以ID为记录


  //折叠面板的
  const active = ref([]);
  //单选框
  const radio1 = ref();
  //多选框
  const checkedList = ref([])



  const departmentList = ref();
  const resourceList = ref();
  const selfResourceList = ref();

  //获取部门列表
  const getdepartmentlistFunction = async () => {
    const res = await getdepartmentlist();
    if (res.code == 200) {
      departmentList.value = res.data.list;

    } else {
      ElMessage.error(res.message);
    }
  };
  //获取全部资源列表
  const getAllDepartmentResourceListFunction = async () => {

    const res = await getAllDepartmentResourceList();
    if (res.code == 200) {

      resourceList.value = res.data.list;

    } else {
      ElMessage.error(res.message);
    }
  };



  //定义当前选中的部门
  const getDepartmentIsResource = (item) => {
    departmentIndex.value = item
    getDepartmentResourceListFunction(departmentIndex.value.id)
  };
  //获取当前选中部门已有的资源
  const getDepartmentResourceListFunction = async (department_id) => {
    const data = {
      department_id:department_id
    }
    const res = await getDepartmentResourceList(data);

    if (res.code == 200) {

      selfResourceList.value = res.data.list;
      checkedList.value = res.data.list

    } else {

      ElMessage.error(res.message);
    }
  };

  //执行一键分配业务资源
  const allocationDepartmenttFunction = async () => {


    if (departmentIndex.value == 0) {
      ElMessage({
        message: "请选择需要操作的部门",
        type: "error",
      })
      return
    }
    const data = {
      department_id: departmentIndex.value.id,
      list: checkedList.value.filter(id => id !== undefined && id !== null)
    }
    const res = await allocationDepartment(data);

    if (res.code == 200) {

      //给个分配成功的提示就好了
      ElMessage({
        message: res.message,
        type: "success",
      })
       checkedList.value = []
      departmentIndex.value = 0
    } else {
      checkedList.value = []
      ElMessage.error(res.message);
    }
  };
</script>

<style lang="scss" scoped>

</style>
